<div class="modal no-overflow show" style="overflow: hidden;" *ngIf="state.visible">
  <div class="modal__box modal__box--small show">
  </div>
</div>

<div class="position-absolute-bottom" *ngIf="state.visible">
  <app-loader></app-loader>
</div>
